import React from 'react'
import { Link } from 'react-router-dom'

const SideBtn = () => {
    return (
        <>
            <div className="side-butn">
        <Link to="/plagiarism-checker"> GET FREE TURNITIN REPORT </Link>
      </div>
        </>
    )
}

export default SideBtn
